// extracted by mini-css-extract-plugin
export var wrap = "page-title-module--wrap--ApfKw";
export var wrap__children = "page-title-module--wrap__children--2rjL7";
export var pageTitle__bg = "page-title-module--pageTitle__bg--uKYDv";
export var pageTitle = "page-title-module--pageTitle--3zHnP";
export var pageTitle__title = "page-title-module--pageTitle__title--34k4T";
export var pageTitle__en = "page-title-module--pageTitle__en--3pz4r";
export var pageTitle_decoration_logo = "page-title-module--pageTitle_decoration_logo--1mWNC";
export var readText = "page-title-module--readText--3qHnK";
export var ipo = "page-title-module--ipo--1n2GT";